import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { Center } from 'legacyComponents/styled/lib';
import { Hero, Logo, Title, Description } from 'apps/microSite/styles';

@withNamespaces()
@observer
export class MicroSiteHero extends React.Component {
  render() {
    const { logo, title, description } = this.props;
    return (
      <>
        <Hero>
          <Center>
            <Logo src={logo} />
          </Center>
          <Center>
            <Title>{title}</Title>
          </Center>
          <Center>
            <Description>{description}</Description>
          </Center>
        </Hero>
      </>
    );
  }
}

MicroSiteHero.propTypes = {
  logo: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};
